import { styled } from "@acko-tech/building-blocks.ui.common";
import type { CSSProperties } from "react";

const PRIMARY_GRADIENT = "linear-gradient(180deg, #8550EB 0%, #A847C1 100%)";
const PRIMARY_SHADOW = "0px 10px 24px rgba(124, 71, 225, 0.35)";

const primaryButtonBase: CSSProperties = {
  borderRadius: "999px",
  background: PRIMARY_GRADIENT,
  color: "#ffffff",
  border: "none",
  cursor: "pointer",
  boxShadow: PRIMARY_SHADOW,
};

export const wrapperBaseStyles: CSSProperties = {
  position: "relative",
  zIndex: 10,
  display: "inline-flex",
  width: "max-content"
};

export const buttonBaseStyles: CSSProperties = {
  ...primaryButtonBase,
  display: "inline-flex",
  alignItems: "center",
  gap: "12px",
  padding: "10px 14px",
  fontFamily: "Euclid Circular B",
  width: "max-content"
};

export const collapsedButtonBaseStyles: CSSProperties = {
  padding: "10px",
  gap: "0px"
};

export const iconOnlyButtonBaseStyles: CSSProperties = {
  ...primaryButtonBase,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "44px",
  height: "44px",
};

export const menuWrapperBaseStyles: CSSProperties = {
  position: "absolute",
  right: "0px",
  bottom: "56px",
  zIndex: 2,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  alignItems: "flex-end",
};

export const menuCardBaseStyles: CSSProperties = {
  background: "#ffffff",
  borderRadius: "16px",
  padding: "16px",
  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.12)",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  minWidth: "0px",
  width: "max-content",
};

export const menuItemBaseStyles: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#040222",
  cursor: "pointer",
};

export const closeButtonBaseStyles: CSSProperties = {
  ...primaryButtonBase,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  padding: "8px 14px",
  fontSize: "14px",
  fontWeight: 500,
};

export const Label = styled.span<{ styles?: string }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 23px;
  white-space: nowrap;
  ${(props) => props.styles}
`;

export const IconWrapper = styled.div<{ styles?: string }>`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: transparent;
  ${(props) => props.styles}
`;

export const IconImage = styled.img<{ styles?: string }>`
  width: 34px;
  height: 34px;
  ${(props) => props.styles}
`;
